import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';

import { getBrokerData } from 'src/store/broker';
import { brokerAgenciesSelector, brokerAgencySelector } from 'src/store/agency';
import {
  dashboardDataSelector,
  getBrokerDashboardData,
  isLoadingDashboardDataSelector,
} from 'src/store/brokerDashboard';

import classes from './dashboard.module.scss';
import { Loader, LoaderWrapper } from 'src/components';

export const BrokerDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { pathname } = useLocation();

  const brokerData = useSelector(getBrokerData);
  const brokerAgencies = useSelector(brokerAgenciesSelector);
  const agencyOwner = brokerAgencies?.find((item) => item?.owner_id === brokerData?.id);

  const agencyData = useSelector(brokerAgencySelector);

  const dashboardData = useSelector(dashboardDataSelector);
  const isLoadingDashboardData = useSelector(isLoadingDashboardDataSelector);

  const isAgency = pathname.includes('teams');
  const teamId = params?.teamId;

  const isInactiveAgency = !_.isEmpty(agencyData)
    ? agencyData && agencyData.status === 'inactive'
    : !agencyOwner;

  useEffect(() => {
    dispatch(getBrokerDashboardData({ isAgency, broker_id: brokerData?.id, org_id: teamId }));
  }, [dispatch, brokerData?.id, isAgency, teamId]);

  const onClickUpgrade = useCallback(() => {
    if (agencyOwner) {
      return navigate(`/teams/${agencyOwner.id}/settings?activeTab=billing`);
    }

    navigate(`/teams/create`);
  }, [navigate, agencyOwner]);

  const onClickAccounts = useCallback(() => {
    const path = !isAgency ? '/broker/accounts' : `/teams/${teamId}/accounts`;

    navigate(path);
  }, [isAgency, navigate, teamId]);

  const onClickProposals = useCallback(() => {
    const path = !isAgency ? '/broker/proposals' : `/teams/${teamId}/proposals`;

    navigate(path);
  }, [isAgency, navigate, teamId]);

  const onClickContacts = useCallback(() => {
    const path = !isAgency ? '/broker/contacts' : `/teams/${teamId}/contacts`;

    navigate(path);
  }, [isAgency, navigate, teamId]);

  const onClickSettings = useCallback(() => {
    const path = !isAgency
      ? '/broker/settings?activeTab=profile'
      : `/teams/${teamId}/settings?activeTab=profile`;

    navigate(path);
  }, [isAgency, navigate, teamId]);

  return (
    <div>
      {isLoadingDashboardData ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          {isInactiveAgency && (
            <div className={classes.BrokerDashboardButton} onClick={onClickUpgrade}>
              Upgrade to PRO
            </div>
          )}
          <h2 className={classes.BrokerDashboardTitle}>Welcome to Monark</h2>
          <div className={classes.BrokerDashboardGrid}>
            <div className={classes.BrokerDashboardItem} onClick={onClickAccounts}>
              <div className={classes.BrokerDashboardItemTitle}>Accounts</div>
              <div className={classes.BrokerDashboardItemCount}>{dashboardData?.accounts}</div>
            </div>
            <div className={classes.BrokerDashboardItem} onClick={onClickProposals}>
              <div className={classes.BrokerDashboardItemTitle}>Proposals</div>
              <div className={classes.BrokerDashboardItemCount}>{dashboardData?.proposals}</div>
            </div>
            <div className={classes.BrokerDashboardItem} onClick={onClickContacts}>
              <div className={classes.BrokerDashboardItemTitle}>Contacts</div>
            </div>
            <div className={classes.BrokerDashboardItem} onClick={onClickSettings}>
              <div className={classes.BrokerDashboardItemTitle}>Settings</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
